<template>
  <div>
    <!-- <span>{{this.row.tag4}}</span> -->
    <el-tag
      v-for="item in tagsArr"
      :key="item"
      size="mini"
      type="info">
      {{item}}
    </el-tag>
    <!-- <el-tag >{{this.row.tag4}}</el-tag> -->
    <el-popover placement="right" trigger="manual" v-model="dialogVisible">
      <el-form >
        <el-form-item >
          <el-input v-model="tag" size="mini" style="width: 200px"></el-input>
          &nbsp;&nbsp;<el-button @click="handleSubmit" size="mini" type="primary" plain>Modify</el-button>
          <el-button @click="CloseDialog" size="mini" plain>Close</el-button>
        </el-form-item>
      </el-form>
      <el-button v-if="this.row.tag4" type="text" slot="reference" @click="toggleDialog">
        &nbsp;&nbsp;<i class="el-icon-edit"></i>
      </el-button>
      <el-button v-else-if="!this.row.tag4" type="text" slot="reference" @click="toggleDialog">
        <i class="el-icon-plus"></i>
      </el-button>
    </el-popover>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { changeProductTag } from '../api'

export default {
  name: 'ColumnLocationDialog',
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  created () {
    if (this.row.tag4 !== '') {
      let value = this.row.tag4
      this.tag = value
      this.tagsArr = value.split('/').sort()
    }
  },
  data () {
    return {
      tag: '',
      dialogVisible: false,
      tagsArr: undefined
    }
  },
  methods: {
    ...mapActions({
      search: 'search/search'
    }),
    toggleDialog () {
      this.dialogVisible = !this.dialogVisible
    },
    CloseDialog () {
      this.tag = this.row.tag4
      this.dialogVisible = false
    },
    async handleSubmit () {
      const params = {
        tag4: this.tag
      }
      await changeProductTag(this.row.id, params)
      this.$message({
        message: 'Operation successful',
        type: 'success'
      })
      this.dialogVisible = false
      this.search()
    }
  },
  watch: {
    'row.tag4': function () {
      let val = this.row.tag4
      this.tagsArr = val ? val.split('/').sort() : []
    }
  }
}
</script>
